/* Joie motion: reveals, word-by-word headings, smooth wheel scroll, magnetic buttons, parallax, scroll progress. */
(function () {
  var d = document, de = d.documentElement, w = window;
  if (w.Shopify && w.Shopify.designMode) return;
  if (!('IntersectionObserver' in w)) return;
  if (w.matchMedia && w.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  w.__joieMotion = true;
  var fine = !!(w.matchMedia && w.matchMedia('(hover: hover) and (pointer: fine)').matches);
  de.classList.add('joie-js');
  if (fine) de.classList.add('joie-fine');

  function ready(fn) { if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', fn); else fn(); }
  function each(list, fn) { Array.prototype.forEach.call(list, fn); }
  function inView(el) { var r = el.getBoundingClientRect(); return r.top < w.innerHeight * 1.2 && r.bottom > 0; }

  function split(el, chars) {
    if (el.getAttribute('data-joie-done')) return;
    el.setAttribute('data-joie-done', '1');
    var label = el.textContent.replace(/\s+/g, ' ').trim();
    var i = 0, nodes = [];
    var walker = d.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
    while (walker.nextNode()) nodes.push(walker.currentNode);
    each(nodes, function (node) {
      if (!node.nodeValue.trim()) return;
      var parts = node.nodeValue.split(/(\s+)/);
      var frag = d.createDocumentFragment();
      each(parts, function (p) {
        if (!p) return;
        if (/^\s+$/.test(p)) { frag.appendChild(d.createTextNode(' ')); return; }
        each(chars ? p.split('') : [p], function (piece) {
          var outer = d.createElement('span');
          outer.className = 'joie-w';
          outer.setAttribute('aria-hidden', 'true');
          var inner = d.createElement('span');
          inner.className = 'joie-wi';
          inner.style.setProperty('--wi', i++);
          inner.textContent = piece;
          outer.appendChild(inner);
          frag.appendChild(outer);
        });
      });
      node.parentNode.replaceChild(frag, node);
    });
    if (!el.getAttribute('aria-label')) el.setAttribute('aria-label', label);
  }

  ready(function () {
    var body = d.body;

    /* 1. Sections settle in; cards fade up just before they reach the screen */
    var sections = Array.prototype.slice.call(d.querySelectorAll('main .shopify-section'));
    var sio = new IntersectionObserver(function (entries) {
      each(entries, function (e) { if (e.isIntersecting) { e.target.classList.add('is-visible'); sio.unobserve(e.target); } });
    }, { rootMargin: '0px 0px 15% 0px', threshold: 0 });
    each(sections, function (section, index) {
      if (index === 0) { section.classList.add('joie-hero'); return; }
      section.classList.add('joie-reveal');
      var n = 0;
      each(section.querySelectorAll('.product-card, .resource-list__item, .collection-card, .joie-trust__item'), function (item) {
        if (item.parentElement && item.parentElement.closest('.joie-stagger')) return;
        item.classList.add('joie-stagger');
        item.style.setProperty('--joie-i', Math.min(n++, 6));
      });
      sio.observe(section);
    });

    /* 2. Headings rise in word by word (footer wordmark letter by letter) */
    var hio = new IntersectionObserver(function (entries) {
      each(entries, function (e) { if (e.isIntersecting) { e.target.classList.add('joie-words-in'); hio.unobserve(e.target); } });
    }, { rootMargin: '0px 0px 5% 0px', threshold: 0 });
    each(d.querySelectorAll('main h1, main h2, [data-joie-split]'), function (h) {
      if (h.closest('.product-card, marquee-component, .card-gallery, dialog, [data-joie-nosplit]')) return;
      var text = h.textContent.replace(/\s+/g, ' ').trim();
      if (!text || text.length > 140) return;
      split(h, h.hasAttribute('data-joie-chars'));
      h.classList.add('joie-split');
      hio.observe(h);
    });

    /* Safety net: never leave anything hidden */
    function sweep() {
      each(sections, function (s) { if (inView(s)) s.classList.add('is-visible'); });
      each(d.querySelectorAll('.joie-split'), function (h) { if (inView(h)) h.classList.add('joie-words-in'); });
    }
    setTimeout(sweep, 1200);

    /* 3. Scroll progress line, grain texture, glass header, layered parallax */
    var bar = d.createElement('div');
    bar.className = 'joie-progress';
    body.appendChild(bar);
    var grain = d.createElement('div');
    grain.className = 'joie-grain';
    body.appendChild(grain);
    var para = w.innerWidth >= 990 ? d.querySelectorAll('[data-joie-speed]') : [];
    var ticking = false, lastSweep = 0;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      w.requestAnimationFrame(function (t) {
        var y = w.scrollY || w.pageYOffset;
        var max = de.scrollHeight - w.innerHeight;
        bar.style.transform = 'scaleX(' + (max > 0 ? Math.min(1, y / max) : 0).toFixed(4) + ')';
        de.classList.toggle('joie-scrolled', y > 40);
        each(para, function (el) {
          var r = el.parentElement.getBoundingClientRect();
          if (r.bottom < -300 || r.top > w.innerHeight + 300) return;
          var s = parseFloat(el.getAttribute('data-joie-speed')) || 0;
          el.style.translate = '0 ' + (y * s).toFixed(1) + 'px';
        });
        if (t - lastSweep > 400) { lastSweep = t; sweep(); }
        ticking = false;
      });
    }
    w.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    if (!fine) return;

    /* 4. Smooth mouse-wheel scrolling (trackpads keep their native feel) */
    var target = 0, current = 0, raf = null;
    de.style.scrollBehavior = 'auto';
    function scrollableParent(el) {
      while (el && el !== body && el !== de) {
        if (el.nodeType === 1) {
          var s = w.getComputedStyle(el);
          if (/(auto|scroll)/.test(s.overflowY) && el.scrollHeight > el.clientHeight + 1) return el;
        }
        el = el.parentElement;
      }
      return null;
    }
    function locked() {
      return d.querySelector('dialog[open]') || w.getComputedStyle(de).overflowY === 'hidden' || w.getComputedStyle(body).overflowY === 'hidden';
    }
    function tick() {
      current += (target - current) * 0.14;
      if (Math.abs(target - current) < 0.5) { current = target; w.scrollTo(0, current); raf = null; return; }
      w.scrollTo(0, current);
      raf = w.requestAnimationFrame(tick);
    }
    w.addEventListener('wheel', function (e) {
      if (e.ctrlKey || e.metaKey || e.defaultPrevented) return;
      if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) return;
      var delta = e.deltaY * (e.deltaMode === 1 ? 40 : e.deltaMode === 2 ? w.innerHeight : 1);
      if (!raf && Math.abs(delta) < 50) return;
      if (locked() || scrollableParent(e.target)) return;
      e.preventDefault();
      if (!raf) { current = w.scrollY || w.pageYOffset; target = current; }
      target = Math.max(0, Math.min(de.scrollHeight - w.innerHeight, target + delta));
      if (!raf) raf = w.requestAnimationFrame(tick);
    }, { passive: false });
    ['mousedown', 'keydown', 'touchstart'].forEach(function (type) {
      w.addEventListener(type, function () { if (raf) { w.cancelAnimationFrame(raf); raf = null; } }, { passive: true });
    });

    /* 5. Magnetic buttons */
    each(d.querySelectorAll('.button:not(.button-unstyled), .custom-btn, .joie-statement__link, .joie-hero-x__link'), function (b) {
      if (b.closest('dialog, .card-gallery, .product-card')) return;
      b.classList.add('joie-magnet');
      b.addEventListener('pointermove', function (e) {
        var r = b.getBoundingClientRect();
        var x = e.clientX - (r.left + r.width / 2);
        var y = e.clientY - (r.top + r.height / 2);
        b.style.translate = (x * 0.14).toFixed(1) + 'px ' + (y * 0.24).toFixed(1) + 'px';
      });
      b.addEventListener('pointerleave', function () { b.style.translate = ''; });
    });
  });
})();
